import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import Link from "@ckeditor/ckeditor5-link/src/link";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import { useEffect, useState } from "react";
const editorConfiguration = {
  plugins: [Essentials, Link, Paragraph],
  toolbar: ["link", "|", "undo", "redo"],
  link: {
    addTargetToExternalLinks: true,
    defaultProtocol: "https://",
  },
};
const TasksCKEditorLink = ({ value, setValue, pageType = "default", pageTypeCalling ,readonly, setRevertedInput, revertedInput, handleAddItem }) => {
  const getWidth = () => {
    if (pageType === "editactivity") return "auto";
    if (pageType === "editactivityfromcontro") return "99.4%";
    if (pageTypeCalling === "crowdsourcing") return "calc(100% + 4px)";
    return "518px";
  };
  useEffect(() => {
    if (revertedInput) {
      setRevertedInput(false);
    }
  }, [revertedInput, value]);
  return (
    <div className={`${pageType === 'editactivity' ? 'taskcustomheight' : 'my-unique-editor'} ${pageType === 'editactivityfromcontro' ? 'taskcustomheight _TaskWidth_latest' : 'my-unique-editor'}`}
      style={{
        width:getWidth(),
        wordBreak: "break-word",
        overflow: "auto",
        height: "auto",
        overflowY: pageType ==="editactivity"?"scroll": "hidden",
        minHeight: "80px", // Ensures minimum height
      }}
    >
        <CKEditor
        onBlur={(event, editor) => {
          if (typeof handleAddItem === "function") {
            handleAddItem();
          }
        }}
        onChange={(event, editor) => {
          if (revertedInput) return;
          setValue(editor.getData());
        }}
        config={editorConfiguration}
        editor={ClassicEditor}
        data={value}
        onReady={(editor) => {
          // Disable controls if readonly is true
          if (readonly) {
            editor.enableReadOnlyMode('my-feature-id'); // Set the editor to read-only mode
          }
        }}
      />
    </div>
  );
};

export default TasksCKEditorLink;

